import { CreateTeaserTypes } from './types'

/**
 * CreateTeaser function docs
 * @param {object} data - An object that define properties for a new teaser
 */
export function CreateTeaser(data: CreateTeaserTypes): Object {
  return data
}
